import { ContactType } from '@/queries/orchestrator/types';

export type ResourceReservationParams = {
  caseId: string;
};

export type OrchestratorResourcesBody = {
  ocsConsoleIds: string[];
  aircraftIds: string[];
  clinicalSpecialistIds: string[];
  surgeonIds: string[];
  employeeIds: string[];
};

export type OperationStatusResponse = {
  correlationId: string | null;
  currentState: string;
  faultedMessage: string | null;
  message: string | null;
};

export enum OperationStateTypes {
  ReserveResource = 'ReserveResource',
  RemoveReservations = 'RemoveReservations',
  ResourcesBookingSend = 'ResourcesBookingSend',
  BookEmployee = 'BookEmployee',
  SwitchOcsConsole = 'SwitchOcsConsole',
  DeleteTxCenter = 'DeleteTxCenter',
  DeleteHospital = 'DeleteHospital',
  DeleteOpo = 'DeleteOpo',
  DeleteHospitalContact = 'DeleteHospitalContact',
  DeleteOpoContact = 'DeleteOpoContact',
  DeleteCustomer = 'DeleteCustomer',
  DeleteHub = 'DeleteHub',
  SwitchResource = 'SwitchResource',
  TransferResources = 'TransferResources',
}

export type SwitchConsoleBody = {
  previousOcsConsoleId: string;
  ocsConsoleId: string;
};

export type SwitchClinicalSpecialistBody = {
  previousResourceId: string;
  resourceId: string;
};

export type DeleteContactBody = {
  id: string;
  type: ContactType;
};
